import React, { Component } from 'react';

class Footer extends Component {
  render() {
    return (
      <footer>
        <span>
          Create by
          <a href="https://github.com/leandrofcr" target="_blank" rel="noreferrer"> Leandro Reis </a>
          using
          <a href="https://reactjs.org/" target="_blank" rel="noreferrer"> React </a>
          . AMONG US is a trademark of
          <a href="https://www.innersloth.com/" target="_blank" rel="noreferrer"> InnerSloth LLC.</a>
        </span>

      </footer>
    );
  }
}

export default Footer;
